import { render, staticRenderFns } from "./BookingItem.vue?vue&type=template&id=a8b2403e&scoped=true&"
import script from "./BookingItem.vue?vue&type=script&lang=ts&"
export * from "./BookingItem.vue?vue&type=script&lang=ts&"
import style0 from "./BookingItem.vue?vue&type=style&index=0&id=a8b2403e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b2403e",
  null
  
)

export default component.exports